const documentWrapper =
  typeof document !== 'undefined' ? document : typeof global !== 'undefined' ? global.document : {}

export default documentWrapper
